import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { IconMail, IconUpload, IconSettings, IconUserCheck, IconSend } from '@tabler/icons';
import UploadInvitationLink from './invitation/UploadInvitationLink';
import ConfirmationEmailSetup from './invitation/ConfirmationEmailSetup';
import AcceptEmailSetup from './invitation/AcceptEmailSetup';
import RejectEmailSetup from './invitation/RejectEmailSetup';
import InterestedInvitations from './invitation/InterestedInvitations';
import SendConfirmationEmails from './invitation/SendConfirmationEmails';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`invitation-tabpanel-${index}`}
            aria-labelledby={`invitation-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

export default function InvitationPage() {
    const { eventId, role } = useParams();
    const [value, setValue] = useState(0);
    const [refetchTrigger, setRefetchTrigger] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleUploadSuccess = () => {
        // Increment trigger to cause MyInvitations to refetch
        setRefetchTrigger((prev) => prev + 1);
        console.log('Upload successful, triggering invitation data refetch...');
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="invitation management tabs"
                    variant="scrollable"
                >
                    <Tab
                        icon={<IconUpload size={20} />}
                        label="Upload List"
                        id="invitation-tab-0"
                        aria-controls="invitation-tabpanel-0"
                    />
                    <Tab
                        icon={<IconSend size={20} />}
                        label="Send Invitations"
                        id="invitation-tab-1"
                        aria-controls="invitation-tabpanel-1"
                    />
                    <Tab
                        icon={<IconUserCheck size={20} />}
                        label="Accepted Invitations"
                        id="invitation-tab-2"
                        aria-controls="invitation-tabpanel-2"
                    />
                    <Tab
                        icon={<IconSettings size={20} />}
                        label="Interested Email Setup"
                        id="invitation-tab-3"
                        aria-controls="invitation-tabpanel-3"
                    />
                    <Tab
                        icon={<IconSettings size={20} />}
                        label="Accept Email Setup"
                        id="invitation-tab-4"
                        aria-controls="invitation-tabpanel-4"
                    />
                    <Tab
                        icon={<IconSettings size={20} />}
                        label="Reject Email Setup"
                        id="invitation-tab-5"
                        aria-controls="invitation-tabpanel-5"
                    />
                </Tabs>
            </Box>

            <TabPanel value={value} index={0}>
                <UploadInvitationLink
                    eventId={eventId}
                    role={role}
                    onUploadSuccess={handleUploadSuccess}
                />
            </TabPanel>

            <TabPanel value={value} index={1}>
                <SendConfirmationEmails eventId={eventId} role={role} />
            </TabPanel>

            <TabPanel value={value} index={2}>
                <InterestedInvitations eventId={eventId} role={role} />
            </TabPanel>

            <TabPanel value={value} index={3}>
                <ConfirmationEmailSetup eventId={eventId} role={role} />
            </TabPanel>

            <TabPanel value={value} index={4}>
                <AcceptEmailSetup eventId={eventId} role={role} />
            </TabPanel>

            <TabPanel value={value} index={5}>
                <RejectEmailSetup eventId={eventId} role={role} />
            </TabPanel>
        </Box>
    );
}
